import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=3d5839ac&scoped=true"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"
import style0 from "./Customize.vue?vue&type=style&index=0&id=3d5839ac&prod&scoped=true&lang=css"
import style1 from "./Customize.vue?vue&type=style&index=1&id=3d5839ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5839ac",
  null
  
)

export default component.exports